import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';

@Component({
  selector: 'slotcom-onboarding-quest-end-modal',
  templateUrl: './onboarding-quest-end.component.html',
  styleUrls: ['./onboarding-quest-end.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class OnboardingQuestEndModalComponent implements OnInit {
  onboardingQuestEndModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private translateService = inject(TranslateService);

  lang: string;
  buttonText: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;

    this.setButtonText();
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.onboardingQuestEndModalData.id, ModalType.View, this.onboardingQuestEndModalData)
    );
  }

  private setButtonText(): void {
    const propertiesButtonText =
      this.onboardingQuestEndModalData.data.properties.buttonText[this.translateService.currentLang];

    this.buttonText = propertiesButtonText ? propertiesButtonText : this.translateService.instant('home.buttons.go');
  }
}
